import UpdateGlobalOptions from "pages/Masters/UpdateGlobalOptions"

export const API_WEB_URLS = {
  // BASE: "http://192.168.31.70:7037/api/V1/",
  // BASE: "https://localhost:44379/api/V1/",
  // BASE: "https://localhost:44379/api/V1/",
  BASE: "https://ApiTradingParty.shinewellsofttech.co.in/api/V1/",
  // BASE: "https://ApiBrokerGta.shinewellsofttech.co.in/api/V1/",
  // BASE: "https://ApiSKumar.shinewellsofttech.co.in/api/V1/",

  LOGIN: "Authentication/Login",
  ForgotPassword_SendOtp: "ForgotPassword/SendOtp",
  ForgotPassword_VerifyOtp: "ForgotPassword/VerifyOtp",
  ForgotPassword_ResetPassword: "ForgotPassword/ResetPassword",
  // IMAGEURL: "https://10.222.92.203:7037/MemberImages/",
  IMAGEURL: "https://ApiBrokerShreeram.shinewellsofttech.co.in/MemberImages/",

  //IMAGEURL_PDF: "https://ApiBrokerShreeram.shinewellsofttech.co.in/MemberImages/PDF/",

  MASTER: "Masters",
  BrokerageCalculation: "BrokerageCalculation",
  VoucherListBro: "VoucherListBro",
  VoucherBro: "VoucherBro",
  LedgerRegisterBro: "LedgerRegisterBro",
  VoucherList: "VoucherList",
  UserMaster: "UserMaster",
  UserMaster: "UserMaster",
  CourseMasterH: "CourseMasterH",
  CourseMasterL: "CourseMasterL",
  UserMasterNew: "UserMasterNew",
  UserTypeMaster: "UserTypeMaster",
  LedgerMaster: "LedgerMaster",
  ReminderData: "ReminderData",
  ItemTypeMaster: "ItemTypeMaster",
  UnitMaster: "UnitMaster",
  ItemMaster: "ItemMaster",
  ContractType: "ContractType",
  TransportMaster: "TransportMaster",
  DeleteContract: "DeleteContract",
  DeletePartyAccount: "DeletePartyAccount",
  DeleteBrokerAccount: "DeleteBrokerAccount",
  BrokerAccount: "BrokerAccount",
  DeleteVoucherNew: "DeleteVoucherNew",
  DeleteVoucherBro: "DeleteVoucherBro",
  DalaliMaster: "DalaliMaster",
  StateMaster: "StateMaster",
  CityMaster: "CityMaster",
  UpdateGlobalOptions: "UpdateGlobalOptions",
  FirmProfile: "FirmProfile",
  ContractH: "ContractH",
  AddLifting: "AddLifting",
  GetLedgerReport: "GetLedgerReport",
  VoucherH: "VoucherH",
  ContractEditData: "ContractEditData",
  ContractEditDataApp: "ContractEditDataApp",
  ContractHHistory: "ContractHHistory",
  ContractForLinkRegister: "ContractForLinkRegister",
  LedgerDalaliCalculation: "LedgerDalaliCalculation",
  PartyNewLedgerBrokerWise: "PartyNewLedger/BrokerWise",
  PartyNewLedgerPartyWise: "PartyNewLedger/PartyWise",
  SaudaPosition: "SaudaPosition",
  ContractMultiPrint: "ContractMultiPrint",
  GetLedgerReportApp: "GetLedgerReportApp",
  PeriodData: "PeriodData",
  GetLedgerReportApp: "GetLedgerReportApp",
  GetDalaliLedgerData: "GetDalaliLedgerData",
  QtyDifferenceAudit: "QtyDifferenceAudit",
  Token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImluZm9Ac2hpbmV3ZWxsaW5ub3ZhdGlvbi5jb20iLCJuYW1laWQiOiIxIiwidW5pcXVlX25hbWUiOiIzMTZiYmI3Ny1kOWIxLTQwNWYtYWRiYy01YzYyN2I0M2YwOWQiLCJJUCI6IjQ5LjQzLjE3Ni45NSIsImlzc3VlZF9kYXRlIjoiMTY5NDQzMjU3MyIsIm5iZiI6MTY5NDQzMjU3MywiZXhwIjoxNjk1MDM3MzczLCJpYXQiOjE2OTQ0MzI1NzMsImlzcyI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSIsImF1ZCI6Imh0dHA6Ly9zaGluZXdlbGxzb2Z0dGVjaC5jby5pbjo1MDY5My9yZXBvcnRpbmcvc2l0ZS9zaXRlMSJ9.thpdYXJuKWTDlStV-HHTv6PViEDZPrSQDO9C3aUo4mM",
}

/**
 * Returns GlobalOptions from localStorage (set at login).
 * Use this everywhere instead of fetching GlobalOptions again.
 * @returns {Array} GlobalOptions list or [] if not set
 */
export const getGlobalOptions = () => {
  try {
    const stored = localStorage.getItem("GlobalOptions")
    if (!stored) return []
    const parsed = JSON.parse(stored)
    return Array.isArray(parsed)
      ? parsed
      : parsed?.dataList
      ? parsed.dataList
      : [parsed]
  } catch {
    return []
  }
}

/** Get active options for the currently logged-in firm */
export const getActiveGlobalOptions = () => {
  const opts = getGlobalOptions()
  if (!opts || opts.length === 0) return null
  let firmId = null
  try {
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      firmId = parsed.FirmId || parsed.firmId || parsed.F_FirmMaster || parsed.f_FirmMaster
    }
    if (!firmId) {
      const firmSub = localStorage.getItem("firmSubscription")
      if (firmSub) {
        const parsedSub = JSON.parse(firmSub)
        firmId = parsedSub.firmId || parsedSub.FirmId || parsedSub.f_FirmMaster
      }
    }
  } catch (e) {}

  if (firmId) {
    const match = opts.find(o => String(o.F_FirmMaster) === String(firmId))
    if (match) return match
  }
  return opts[0] || null
}

/** Get default financial year id from GlobalOptions */
export const getDefaultFinancialYearId = () => {
  const opt = getActiveGlobalOptions()
  if (opt && opt.F_FinancialYearMaster != null) {
    return opt.F_FinancialYearMaster
  }
  const opts = getGlobalOptions()
  if (opts && opts.length > 0 && opts[0].F_FinancialYearMaster != null) {
    return opts[0].F_FinancialYearMaster
  }
  return 0
}

/** Company/Firm name from logged-in firm profile / authUser / firmSubscription. */
export const getCompanyName = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const name = parsed?.FirmName || parsed?.firmName
      if (name && name !== "Default Firm") {
        return String(name).trim()
      }
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const name = parsed?.FirmName || parsed?.firmName
      if (name && name !== "Default Firm") {
        return String(name).trim()
      }
    }
    const firmSub = localStorage.getItem("firmSubscription")
    if (firmSub) {
      const parsedSub = JSON.parse(firmSub)
      const name = parsedSub?.firmName || parsedSub?.FirmName
      if (name && name !== "Default Firm") {
        return String(name).trim()
      }
    }
  } catch (e) {}

  return "My Trading Firm"
}

/** Address from logged-in firm profile or authUser */
export const getCompanyAddress = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const parts = [parsed.Address || parsed.address, parsed.City || parsed.city, parsed.State || parsed.state]
        .filter(Boolean)
        .map(s => String(s).trim())
      if (parts.length) return parts.join(", ")
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const parts = [parsed.Address || parsed.address, parsed.City || parsed.city, parsed.State || parsed.state]
        .filter(Boolean)
        .map(s => String(s).trim())
      if (parts.length) return parts.join(", ")
    }
  } catch (e) {}

  const opt = getActiveGlobalOptions()
  if (opt) {
    const parts = [opt.Address, opt.City, opt.State]
      .filter(Boolean)
      .map(s => String(s).trim())
    if (parts.length) return parts.join(", ")
  }
  return ""
}

export const getCompanyCity = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      if (parsed.City || parsed.city) return String(parsed.City || parsed.city).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      if (parsed.City || parsed.city) return String(parsed.City || parsed.city).trim()
    }
  } catch (e) {}
  const opt = getActiveGlobalOptions()
  if (opt && opt.City) return String(opt.City).trim()
  return ""
}

export const getCompanyState = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      if (parsed.State || parsed.state) return String(parsed.State || parsed.state).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      if (parsed.State || parsed.state) return String(parsed.State || parsed.state).trim()
    }
  } catch (e) {}
  const opt = getActiveGlobalOptions()
  if (opt && opt.State) return String(opt.State).trim()
  return ""
}

export const getCompanyGstNo = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const gst = parsed.GSTNo || parsed.gstNo || parsed.GstNo
      if (gst) return String(gst).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const gst = parsed.GstNo || parsed.gstNo || parsed.GSTNo
      if (gst) return String(gst).trim()
    }
  } catch (e) {}
  const opt = getActiveGlobalOptions()
  if (opt && opt.GstNo) return String(opt.GstNo).trim()
  return ""
}

export const getCompanyPanNo = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const pan = parsed.PanNo || parsed.panNo || parsed.PANNo
      if (pan) return String(pan).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const pan = parsed.PanNo || parsed.panNo
      if (pan) return String(pan).trim()
    }
  } catch (e) {}
  const opt = getActiveGlobalOptions()
  if (opt && opt.PanNo) return String(opt.PanNo).trim()
  return ""
}

export const getCompanyMobile = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const mob = parsed.MobileNo || parsed.mobileNo || parsed.Mobile || parsed.mobile
      if (mob) return String(mob).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const mob = parsed.MobileNo || parsed.mobileNo || parsed.Mobile || parsed.mobile
      if (mob) return String(mob).trim()
    }
  } catch (e) {}
  const opt = getActiveGlobalOptions()
  if (opt && opt.Mobile) return String(opt.Mobile).trim()
  return ""
}

export const getCompanyEmail = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const em = parsed.Email || parsed.email
      if (em) return String(em).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const em = parsed.Email || parsed.email || parsed.username
      if (em && String(em).includes("@")) return String(em).trim()
    }
  } catch (e) {}
  const opt = getActiveGlobalOptions()
  if (opt && opt.Email) return String(opt.Email).trim()
  return ""
}

export const getCompanyPincode = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile")
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile)
      const pin = parsed.Pincode || parsed.pincode
      if (pin) return String(pin).trim()
    }
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      const parsed = JSON.parse(authUser)
      const pin = parsed.Pincode || parsed.pincode
      if (pin) return String(pin).trim()
    }
  } catch (e) {}
  return ""
}

